$(document).ready(function () {
  $(".homepage-products-heading-2").html("").append(hpBestSellersHeading);
  $(".homepage-products-heading-8").html("").append(hpActionHeading);


  $(".benefitBanner__data .banners").insertAfter($(".homepage-products-2"));

});
